import { Spacing8 } from 'autogen/design-tokens/tokens';
import type { BasketLineViewModel } from 'autogen/swagger/all';
import Flex from 'components/Layout/components/Flex';
import { Price } from 'components/generic/productPrice';
import { useTranslation } from 'react-i18next';
import PriceWithDiscount from 'components/generic/productPrice/components/PriceWithDiscount';
import SubscriptionPriceHereAfter from 'components/basket/BasketItem/components/Subscription/components/SubscriptionPriceHereAfter';
import { SubPriceLabel, SubscriptionOnlyLabel } from 'autogen/translation-keys/trans-website-basket-subscription';
import Text from 'components/generic/typography/components/Text';

export default function SubscriptionPrice({
    model: {
        productId,
        priceInfo: { subtotal, hasDiscount, subtotalBefore },
        subscriptionInfo,
        subscriptionOnly
    }
}: {
    model: BasketLineViewModel;
}) {
    const { t } = useTranslation();

    if (!subscriptionInfo) return null;

    const { showSubscriptionPrice } = subscriptionInfo;

    if (subscriptionOnly) {
        return (
            <Flex.Column gap={Spacing8}>
                <Text size={14}>{t(SubscriptionOnlyLabel)}</Text>
                {showSubscriptionPrice && <SubscriptionPriceHereAfter model={subscriptionInfo} productId={productId} />}
            </Flex.Column>
        );
    }

    return (
        <Flex.Column gap={Spacing8}>
            {hasDiscount ? (
                <PriceWithDiscount size={14} price={`${t(SubPriceLabel)} ${subtotal}`} priceBefore={subtotalBefore} />
            ) : (
                <Price size={14} price={`${t(SubPriceLabel)} ${subtotal}`} />
            )}
            {showSubscriptionPrice && <SubscriptionPriceHereAfter model={subscriptionInfo} productId={productId} />}
        </Flex.Column>
    );
}
